<template>
    <div class="px-4 py-2">
        <h2>Medidores Triortogonais</h2>
        <b-row align-h="center" cols="1">
            <b-col cols="12" lg="9">
                <triaxial-joint-filters
                    @update="update"
                    @start-loading="loading = true"
                    @finish-loading="loading = false"
                />
            </b-col>
            <b-col cols="12" lg="9" class="mt-3">
                <triaxial-joint-chart
                    ref="triaxialJointChart"
                    :loading="loading"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import TriaxialJointFilters from "./components/TriaxialJointFilters";
import TriaxialJointChart from "./components/TriaxialJointChart";
import api from "../../api";

export default {
    name: "TriaxialJoint",
    components: {
        TriaxialJointFilters,
        TriaxialJointChart
    },
    data() {
        return {
            loading: false
        };
    },
    created() {
        this.dateInterval = {};
        this.triaxialJointsResults = [];
        this.triaxialJointsReadings = [];
        this.concreteTemperatureReadings = [];
    },
    methods: {
        async update({ callback, params }) {
            const { dateInterval } = params;

            if (this.needFetchAgain(dateInterval)) {
                this.dateInterval = dateInterval;

                const { startDate, endDate } = this.dateInterval;
                const [
                    triaxialResulst,
                    triaxialReadings,
                    tempReadings
                ] = await Promise.all([
                    api.triaxialJoints.results(startDate, endDate),
                    api.triaxialJoints.readings(startDate, endDate),
                    api.concreteTemperatureThermometers.readings(
                        startDate,
                        endDate
                    )
                ]);

                this.triaxialJointsResults = triaxialResulst.data;
                this.triaxialJointsReadings = triaxialReadings.data;
                this.concreteTemperatureReadings = tempReadings.data;
            }

            await this.$refs.triaxialJointChart.update({
                params,
                triaxialJointsResults: this.triaxialJointsResults,
                triaxialJointsReadings: this.triaxialJointsReadings,
                concreteTemperatureReadings: this.concreteTemperatureReadings
            });

            callback();
        },
        needFetchAgain(dateInterval) {
            return (
                this.dateInterval.startDate !== dateInterval.startDate ||
                this.dateInterval.endDate !== dateInterval.endDate
            );
        }
    }
};
</script>
